import { useTranslations } from "next-intl";
import { memo } from "react";
import { useFiltersList } from "@hooks/use-features";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import AccessoriesSection from "./AccessoriesSection";
import FilterCheckbox from "./Elements/FilterCheckbox";

const filterSectionKey = "category";

const CategorySection = memo(function CategorySection({
  categoryItems,
  refineCategory,
  listingPage,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
}) {
  const t = useTranslations("catalog");

  const filtersList = useFiltersList();

  if (shouldHideFilterSectionInListingPage(listingPage, "clothes")) return null;
  if (shouldHideFilterSectionInListingPage(listingPage, "accessories")) return null;
  if (shouldHideFilterSectionInListingPage(listingPage, "subcategory")) return null;
  if (categoryItems.length < 2) return null;

  const sectionTitle = t(`filters.section_titles.${filterSectionKey}`);

  function displayClothesFiltersOptions() {
    return filtersList.clothes.map((filter) => {
      const item = categoryItems.find((categoryItem) => categoryItem.value === filter);

      if (!item) return;

      return (
        <FilterCheckbox
          key={`filter-${filter}`}
          label={t(`filters.clothes.${filter}`)}
          filterType="clothes"
          filterSectionKey={filterSectionKey}
          item={item}
          refine={refineCategory}
        />
      );
    });
  }

  const checkedFilters = {
    clothes: filtersList.clothes.filter(
      (clothe) => categoryItems.find((item) => item.value === clothe)?.isRefined,
    ),
    accessories: filtersList.accessories.filter(
      (accessory) => categoryItems.find((item) => item.value === accessory)?.isRefined,
    ),
  };

  return (
    <div>
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["clothes", "accessories"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />

      <SectionContent
        isOpen={[filterSectionKey, "accessories"].includes(filterSectionOpened)}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("")}
        title={sectionTitle}
      >
        {displayClothesFiltersOptions()}
        <AccessoriesSection
          categoryItems={categoryItems}
          refineCategory={refineCategory}
          onClose={onClose}
          filterSectionOpened={filterSectionOpened}
          setFilterSectionOpened={setFilterSectionOpened}
        />
      </SectionContent>
    </div>
  );
});

export default CategorySection;
